import { PrimaryButton, Reveal } from "@/components/ui-bits";
import { ServiceTag, CapList, ImageFrame } from "@/pages/services/bits";

const CAPABILITIES = [
  "RECURRING DAILY ROUTES",
  "RECURRING WEEKLY ROUTES",
  "DEDICATED TRUCK CAPACITY",
  "DEDICATED DRIVER OPTIONS",
  "CONSISTENT EQUIPMENT",
  "TRANSPORTATION PLANNING",
];

const ServiceDedicated = () => {
  return (
    <section id="dedicated" data-testid="service-dedicated" aria-labelledby="dedicated-heading" className="scroll-mt-24 bg-[#f7f8f9] py-16 sm:py-20 lg:py-24">
      <div className="container-30 grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <Reveal className="order-2 lg:order-1">
          <ServiceTag number="02" label="Dedicated Service" />
          <h2 id="dedicated-heading" data-testid="dedicated-headline" className="mt-6 font-display text-3xl font-extrabold leading-[1.08] tracking-tight text-[#191c1e] sm:text-4xl">
            DEDICATED TRANSPORTATION
          </h2>
          <p className="mt-3 font-display text-lg font-semibold text-[#191c1e]/80">
            Consistent transportation built around your operation.
          </p>
          <p className="mt-5 text-base leading-relaxed text-[#5f666d]">
            For businesses with recurring transportation requirements, dedicated service provides consistent capacity
            built around your lanes, schedules and operational needs.
          </p>
          <div className="mt-8">
            <CapList items={CAPABILITIES} testid="dedicated-capabilities" />
          </div>
          <div className="mt-10">
            <PrimaryButton to="/request-a-quote" testid="dedicated-cta">
              DISCUSS DEDICATED SERVICE
            </PrimaryButton>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="order-1 lg:order-2">
          <ImageFrame
            src="/assets/dedicated-truck.webp"
            alt="A 30 NORTH tractor-trailer at the dock doors of a modern distribution centre in the Toronto area"
            testid="dedicated-image"
            caption={<>RECURRING LANES <span className="ml-2 text-[#ff6a00]">CONSISTENT CAPACITY</span></>}
          />
        </Reveal>
      </div>
    </section>
  );
};

export default ServiceDedicated;
